import React, { useState, useCallback, useEffect, useMemo, useRef } from "react";

// Third party and library
import { Button, ButtonGroup, Form, Modal, Spinner, ListGroup, Badge, Tabs, Tab } from "react-bootstrap";
import useReactRouter from "use-react-router";
import _ from 'lodash';
import NumberFormat from "react-number-format";
import { useToasts } from "react-toast-notifications";
import { useMutation, useQuery } from "@apollo/client";
import { GET_STOCKS_IN_LIVE } from "../../../graphql/stock/query";



// Component and constants
import { COLOR_APP } from "../../../constants";
 
import { CREATE_STOCK_AND_PRODUCTS, CREATE_LIVE_STOCK } from "../../../graphql/liveStock/mutation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTimes, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { GET_OPTION_VALUES } from "../../../graphql/optionValue/query";
import LoadingSpinner from "../../../components/LoadingSpinner";
import Select, { components } from "react-select";
import useWindowDimensions from "../../../helpers/useWindowDimensions";

function AddStockModal({
   fetchLiveStocks,
   liveId,
   showAddStockModal,
   setShowAddStockModal,
   selectedComment,
   liveStocks = [],
   setLiveStocks,
   seTotalLiveStock,
   getStocks,
   stockData,
   stockLoading
}) {
   const { width } = useWindowDimensions();
   const { history, match } = useReactRouter();
   const { addToast } = useToasts();
   const shopId = localStorage.getItem("SHOP");

   // State with default values
   const [optionValues, setOptionValues] = useState([])
   const [selectedOptionRows, setSelectedOptionRows] = useState([])
   const [selectedPrimary, setSelectedPrimary] = useState([])
   const [secondaryGroupName, setSecondaryGroupName] = useState("")
   const [selectedSecondary, setSelectedSecondary] = useState([])
   const [currency, setCurrency] = useState("ກີບ");
   const [cfMessage, setCfMessage] = useState("");
   const [productTital, setProductTital] = useState("");
   const [stockPriceLak, setStockPriceLak] = useState("");
   const [stockOriginPriceLak, setStockOriginPriceLak] = useState("");
   const [stockAmount, setStockAmount] = useState("");
   const [selectedOptions, setSelectedOptions] = useState([]);
   const [activeTab, setActiveTab] = useState("new");
   const [existingProductName, setExistingProductName] = useState("");
   const [selectedExistingStock, setSelectedExistingStock] = useState(null);
   const [existingAmount, setExistingAmount] = useState("");
   const [price, setPrice] = useState("");
   const [page, setPage] = useState({ skip: 0, limit: 100 });
   const [fetchingMore, setFetchingMore] = useState(false);
   const [searchKeyword, setSearchKeyword] = useState("");
   const [searchInput, setSearchInput] = useState("");
   

   const [createStockAndProducts, { loading: createLoading }] = useMutation(CREATE_STOCK_AND_PRODUCTS);
   const [createLiveStock, { loading: createExistingLoading }] = useMutation(CREATE_LIVE_STOCK);

   // Query for option values
   const { loading: stocksLoading, error: stocksError, data: stocksData, refetch: refetchStocks, fetchMore } = useQuery(GET_STOCKS_IN_LIVE, {
      fetchPolicy: "cache-first",
      variables: {
         where: {
            isDeleted: false,
            shop: shopId,
            ...(searchKeyword ? { OR: [{ name: searchKeyword }, { cfMessage: searchKeyword }] } : {}),
         },
         orderBy: "createdAt_DESC",
         skip: page.skip,
         limit: page.limit,
      },
   })

   useEffect(() => {
      const t = setTimeout(() => {
         setSearchKeyword(searchInput || "");
      }, 1500);
      return () => clearTimeout(t);
   }, [searchInput]);

   // useEffect hooks
   useEffect(() => {
      if (stocksData) {
         const _optionPrepare = _.groupBy(stocksData?.stocksInLive?.data, "name")

         setOptionValues(_optionPrepare)
      }
   }, [stocksData])

   useEffect(() => {
      if (activeTab === "existing") {
         refetchStocks();
      }
   }, [activeTab])




   // Field validation helper
   const validateFields = () => {
      if (_.isEmpty(productTital?.trim())) {
         addToast("ປ້ອນຊື່ສີນຄ້າກ່ອນ", {
            appearance: 'warning',
            autoDismiss: true,
         });
         return false;
      }

      if (_.isEmpty(cfMessage?.trim())) {
         addToast("ປ້ອນລະຫັດ CF ກ່ອນ", {
            appearance: 'warning',
            autoDismiss: true,
         });
         return false;
      }

      if (_.isEmpty(stockPriceLak)) {
         addToast("ປ້ອນລາຄາກ່ອນ", {
            appearance: 'warning',
            autoDismiss: true,
         });
         return false;
      }

      if (_.isEmpty(stockAmount)) {
         addToast("ປ້ອນຈໍານວນກ່ອນ", {
            appearance: 'warning',
            autoDismiss: true,
         });
         return false;
      }

      // Check for duplicate CF
      const checkAlreadyStock = liveStocks.filter(item =>
         item.cfMessage?.toLowerCase() === cfMessage?.trim().toLowerCase()
      );

      if (checkAlreadyStock.length > 0) {
         addToast("ສິນຄ້າລະຫັດ CF ນີ້ມີຢູ່ໃນໄລຟຢູ່ແລ້ວ", {
            appearance: 'error',
            autoDismiss: true,
         });
         return false;
      }

      return true;
   };

   // Parse number from formatted string
   const parseNumber = (value) => {
      return parseFloat((value || "0").toString().replace(/,/g, '')) || 0;
   };

   const loadMoreStocks = async () => {
      if (fetchingMore) return;
      const current = (stocksData?.stocksInLive?.data || []).length;
      const total = stocksData?.stocksInLive?.total || 0;
      if (current >= total) return;
      setFetchingMore(true);
      try {
         await fetchMore({
            variables: { skip: current, limit: page.limit },
            updateQuery: (prev, { fetchMoreResult }) => {
               if (!fetchMoreResult) return prev;
               const next = fetchMoreResult.stocksInLive;
               return {
                  stocksInLive: {
                     ...next,
                     data: [
                        ...((prev?.stocksInLive?.data) || []),
                        ...((next?.data) || [])
                     ]
                  }
               };
            }
         });
      } finally {
         setFetchingMore(false);
      }
   };

   const selectOptions = useMemo(() => {
      const list = (stocksData?.stocksInLive?.data || []).filter((item) => (item?.amount || 0) > 0);
      return list.map((item) => ({
         value: item?.cfMessage || "",
         label: `ລະຫັດ: ${item?.cfMessage || ""} — ສິນຄ້າ: ${item?.name || "-" } — ຈໍານວນ: ${item?.amount || 0}`
      }));
   }, [stocksData]);

   const onSelectExistingStockOption = (option) => {
      if (!option) {
         setExistingProductName("");
         setSelectedExistingStock(null);
         setExistingAmount("");
         setPrice("");
         return;
      }
      const cf = option?.value || "";
      const found = (stocksData?.stocksInLive?.data || []).find((item) => item?.cfMessage === cf);
      if (found) {
         setExistingProductName(found?.name || "");
         setSelectedExistingStock(found);
         setExistingAmount(((found?.amount ?? "") + ""));
         setPrice(((found?.price ?? "") + ""));
      }
   };

   const menuScrollTopRef = useRef(0);
   const MenuList = (props) => {
      const listRef = useRef(null);
      useEffect(() => {
         if (!listRef.current) {
            listRef.current = document.getElementById("rs-menu-list");
         }
         if (listRef.current) {
            listRef.current.scrollTop = menuScrollTopRef.current;
         }
      }, [props.children]);
      const onScroll = (e) => {
         menuScrollTopRef.current = e.target.scrollTop;
         if (props?.innerProps?.onScroll) props.innerProps.onScroll(e);
      };
      const innerProps = { ...(props.innerProps || {}), id: "rs-menu-list", onScroll };
      const current = (stocksData?.stocksInLive?.data || []).length;
      const total = stocksData?.stocksInLive?.total || 0;
      const hasMore = current < total;
      return (
         <components.MenuList {...props} innerProps={innerProps} innerRef={listRef}>
            {props.children}
            {hasMore && !fetchingMore && (
               <div style={{ padding: 8, textAlign: "center" }}>
                  <Button size="sm" variant="outline-primary" onClick={loadMoreStocks}>
                     ໂຫລດຂໍ້ມູນເພີ່ມເຕີມ
                  </Button>
               </div>
            )}
            {fetchingMore && (
               <div style={{ padding: 8, textAlign: "center" }}>
                  <Spinner animation="border" size="sm" />
               </div>
            )}
         </components.MenuList>
      );
   };

   // Reset form fields
   const resetForm = useCallback(() => {
      setCurrency("ກີບ");
      setCfMessage("");
      setProductTital("");
      setStockPriceLak("");
      setStockOriginPriceLak("");
      setStockAmount("");
   }, []);

   const { data: optionValueDatas, loading: optionLoading } = useQuery(GET_OPTION_VALUES, {
      fetchPolicy: "cache-and-network",
      variables: {
         where: {
            isDeleted: false,
            shop: shopId,
         },
         orderBy: "createdAt_ASC",
         skip: 0,
         limit: 1000,
      },
   });

   const optionGroups = useMemo(() => {
      const list = optionValueDatas?.optionValues?.data || [];
      return _.groupBy(list, "name");
   }, [optionValueDatas]);

   useEffect(() => {
      const names = Object.keys(optionGroups || {});
      if (!secondaryGroupName && names.length > 0) {
         setSecondaryGroupName(names[0]);
      }
   }, [optionGroups, secondaryGroupName]);

   const checkSelectedSecondaryVal = useCallback((val) => {
      return selectedSecondary.some((r) => r.id === val?.id);
   }, [selectedSecondary]);

   const onTogglePrimary = useCallback((groupName, val) => {
      if (!val?.id) return;
      setSelectedPrimary((prev) => {
         const exists = prev.find((r) => r.id === val.id);
         if (exists) {
            const nextPrimary = prev.filter((r) => r.id !== val.id);
            setSelectedOptionRows((rows) => rows.filter((r) => r.primary?.id !== val.id));
            return nextPrimary;
         }
         const nextPrimary = [...prev, { id: val.id, name: val.name, value: val.value, group: groupName }];
         setSelectedOptionRows((rows) => {
            const combos = selectedSecondary.length > 0 ? selectedSecondary : [{ id: null, name: "", value: "" }];
            const newRows = combos
               .filter((s) => s.id)
               .map((s) => ({
                  primary: { id: val.id, name: val.name, value: val.value, group: groupName },
                  secondary: { id: s.id, name: s.name, value: s.value, group: secondaryGroupName },
                  amount: "",
                  price: "",
                  originPrice: "",
                  cfMessage: "",
               }));
            return [...rows, ...newRows];
         });
         return nextPrimary;
      });
   }, [selectedSecondary, secondaryGroupName]);

   const onToggleSecondary = useCallback((val) => {
      if (!val?.id) return;
      setSelectedSecondary((prev) => {
         const exists = prev.find((r) => r.id === val.id);
         if (exists) {
            const nextSecondary = prev.filter((r) => r.id !== val.id);
            setSelectedOptionRows((rows) => rows.filter((r) => r.secondary?.id !== val.id));
            return nextSecondary;
         }
         const nextSecondary = [...prev, { id: val.id, name: val.name, value: val.value }];
         setSelectedOptionRows((rows) => {
            const newRows = selectedPrimary.map((p) => ({
               primary: p,
               secondary: { id: val.id, name: val.name, value: val.value, group: secondaryGroupName },
               amount: "",
               price: "",
               originPrice: "",
               cfMessage: "",
            }));
            return [...rows, ...newRows];
         });
         return nextSecondary;
      });
   }, [selectedPrimary, secondaryGroupName]);

   const updateSelectedRow = useCallback((primaryId, secondaryId, changes) => {
      setSelectedOptionRows((prev) => prev.map((r) => (r.primary?.id === primaryId && r.secondary?.id === secondaryId ? { ...r, ...changes } : r)));
   }, []);

   const onGenOption = useCallback(() => {
      const base = (cfMessage?.trim() || productTital?.trim() || "CF").toUpperCase();
      const defaultAmount = parseNumber(stockAmount) || 1;
      const defaultOriginPrice = parseNumber(stockOriginPriceLak) || 0;
      const defaultPrice = parseNumber(stockPriceLak) || 0;
      const allOptions = optionValueDatas?.optionValues?.data || [];

      setSelectedOptionRows((prev) => {
         if (prev.length === 0) {
            const selected = selectedOptions
               .map((id) => allOptions.find((o) => o.id === id))
               .filter(Boolean);

            const groupsMap = _.groupBy(selected, 'name');
            const groupNames = Object.keys(groupsMap);
            const arrays = groupNames.map((name) => groupsMap[name]);
            const combos = arrays.length > 0
               ? arrays.reduce((acc, curr) => acc.flatMap((prev) => curr.map((item) => [...prev, item])), [[]])
               : [];

            const rows = (combos.length > 0 ? combos : selected.map((opt) => [opt])).map((combo) => {
               const normVals = combo.map((c) => (c?.value || '').toString().trim().toUpperCase().replace(/\s+/g, ''));
               const generated = [base, ...normVals].filter(Boolean).join('');
               const optionIds = combo.map((c) => c.id).filter(Boolean);

               const primaryOpt = combo[0] || null;
               const secondaryOpt = combo[1] || null;

               return {
                  primary: primaryOpt ? { id: primaryOpt.id, name: primaryOpt.name, value: primaryOpt.value, group: primaryOpt.name } : { id: null, name: '', value: '', group: 'Option' },
                  secondary: secondaryOpt ? { id: secondaryOpt.id, name: secondaryOpt.name, value: secondaryOpt.value, group: secondaryOpt.name } : { id: null, name: '', value: '', group: primaryOpt?.name || 'Option' },
                  amount: `${defaultAmount}`,
                  originPrice: `${defaultOriginPrice}`,
                  price: `${defaultPrice}`,
                  cfMessage: generated,
                  optionIds,
               };
            });
            return rows;
         }

         return prev.map((r) => {
            const pRaw = (r.primary?.value || "").toString().trim();
            const sRaw = (r.secondary?.value || "").toString().trim();
            const p = pRaw.toUpperCase().replace(/\s+/g, "");
            const s = sRaw.toUpperCase().replace(/\s+/g, "");
            const generated = [base, p || s ? (p || s) : null, p && s ? s : null].filter(Boolean).join("");
            const nextAmount = r.amount && parseNumber(r.amount) > 0 ? r.amount : `${defaultAmount}`;
            const nextOriginPrice = parseNumber(r.originPrice) > 0 ? r.originPrice : `${defaultOriginPrice}`;
            const nextPrice = parseNumber(r.price) > 0 ? r.price : `${defaultPrice}`;
            return { ...r, cfMessage: r.cfMessage && r.cfMessage.trim() ? r.cfMessage : generated, amount: nextAmount, originPrice: nextOriginPrice, price: nextPrice };
         });
      });
   }, [cfMessage, productTital, stockAmount, stockOriginPriceLak, stockPriceLak, selectedOptions, optionValueDatas]);

   // Handle form submission
   const onAddNewStock = async () => {
      try {
         if (createLoading) return;

         if (selectedOptions && selectedOptions.length > 0 && selectedOptionRows.length === 0) {
            addToast("ເລືອກ option ແລ້ວກົດ \"ສ້າງລະຫັດ\" ກ່ອນ", { appearance: "warning", autoDismiss: true });
            return;
         }

         const usingOptions = selectedOptionRows.length > 0;
         if (!usingOptions) {
            if (!validateFields()) return;
         } else {
            if (_.isEmpty(productTital?.trim())) {
               addToast("ປ້ອນຊື່ສີນຄ້າກ່ອນ", { appearance: "warning", autoDismiss: true });
               return;
            }
            if (selectedOptionRows.every((r) => _.isEmpty(r.amount))) {
               addToast("ໃສ່ຈໍານວນຂອງຕົວເລືອກກ່ອນ", { appearance: "warning", autoDismiss: true });
               return;
            }
         }

         const SHOP_ID = localStorage.getItem("SHOP");
         const currentLiveId = match.params?.liveId || liveId;

         if (!SHOP_ID || !currentLiveId) {
            addToast("ຂໍ້ມູນ Shop ຫຼື Live ບໍ່ຖືກຕ້ອງ", {
               appearance: 'error',
               autoDismiss: true,
            });
            return;
         }

            if (!usingOptions) {
               const price = parseNumber(stockPriceLak);
               const originPrice = parseNumber(stockOriginPriceLak);
               const amount = parseNumber(stockAmount);
               let dataNew = {
               price,
               originPrice,
               currency,
               amount,
               name: productTital.trim(),
               cfMessage: cfMessage.trim(),
               shop: SHOP_ID,
               live: currentLiveId,
            };
            if (selectedOptions && selectedOptions.length > 0) {
               dataNew = { ...dataNew, optionValues: selectedOptions };
            }
            const productData = {
               name: productTital?.trim() || "",
               unit: "",
               image: "",
               shop: SHOP_ID,
               live: currentLiveId,
            };
            await createStockAndProducts({ variables: { data: { product: productData, stocks: [dataNew] } } });
            addToast("ເພີ່ມສິນຄ້າສໍາເລັດ", { appearance: "success", autoDismiss: true });
            fetchLiveStocks();
            setShowAddStockModal(false);
            resetForm();
            setSelectedOptions([]);
            setSelectedOptionRows([]);
         } else {
            const dataList = selectedOptionRows
               .map((r) => ({
                  cfMessage: (r.cfMessage || `${(cfMessage?.trim() || productTital?.trim() || '').toUpperCase()}${(r.primary?.value || '').toString().toUpperCase()}${(r.secondary?.value || '').toString().toUpperCase()}`).trim(),
                  name: productTital?.trim() || "",
                  unit: "",
                  amount: parseNumber(r.amount),
                  originPrice: parseNumber(r.originPrice),
                  price: parseNumber(r.price),
                  currency,
                  shop: SHOP_ID,
                  live: currentLiveId,
                  optionValues: (r.optionIds && r.optionIds.length > 0) ? r.optionIds : [r.primary?.id, r.secondary?.id].filter(Boolean),
                  image: "",
               }))
               .filter((s) => s.amount > 0 && s.price >= 0);

            if (dataList.length === 0) {
               addToast("ກະລຸນາໃສ່ຂໍ້ມູນສິນຄ້າຂອງຕົວເລືອກ", { appearance: "warning", autoDismiss: true });
               return;
            }
            const productData = {
               name: productTital?.trim() || "",
               unit: "",
               image: "",
               shop: SHOP_ID,
               live: currentLiveId,
            };
            const _createMany = await createStockAndProducts({ variables: { data: { product: productData, stocks: dataList } } });
            addToast("ເພີ່ມສິນຄ້າສໍາເລັດ", { appearance: "success", autoDismiss: true });
            fetchLiveStocks();
            setShowAddStockModal(false);
            resetForm();
            setSelectedOptions([]);
            setSelectedOptionRows([]);
         }
      } catch (error) {
         console.error("Error adding stock:", error);

         if (error.toString().includes("STOCK_WITH_THIS_CF_MESSAGE_ALREADY_EXITS")) {
            addToast("ສິນຄ້າລະຫັດ CF ນີ້ມີຢູ່ໃນສະຕ໊ອກສິນຄ້າຢູ່ແລ້ວ", {
               appearance: 'error',
               autoDismiss: true,
            });
         } else {
            addToast("ເກີດຂໍ້ຜິດພາດໃນການເພີ່ມສິນຄ້າ", {
               appearance: 'error',
               autoDismiss: true,
            });
         }
      }
   };

   const handleClose = () => {
      if (createLoading) return;
      setShowAddStockModal(false);
   };

   // Toggle option selection
   const handleOptionSelect = (option) => {
      if (!option || !option.id || !option.value) {
         console.error("Invalid option provided");
         return;
      }

      // Toggle the option in the selected options
      setSelectedOptions(prevOptions => {
         const isSelected = prevOptions.includes(option.id);
         const newOptions = isSelected
            ? prevOptions.filter(id => id !== option.id)
            : [...prevOptions, option.id];
         return newOptions;
      });
   };


   const onAddExistingStock = async () => {
      try {
         // if (createExistingLoading) return;
         if (createExistingLoading) return;

         const SHOP_ID = localStorage.getItem("SHOP");
         const currentLiveId = match.params?.liveId || liveId;

         if (!SHOP_ID || !currentLiveId) {
            addToast("ຂໍ້ມູນ Shop ຫຼື Live ບໍ່ຖືກຕ້ອງ", {
               appearance: 'error',
               autoDismiss: true,
            });
            return;
         }

         if (!selectedExistingStock) {
            addToast("ເລືອກສິນຄ້າກ່ອນ", {
               appearance: 'warning',
               autoDismiss: true,
            });
            return;
         }

         const amount = parseNumber(existingAmount);
         if (!amount || amount <= 0) {
            addToast("ປ້ອນຈໍານວນກ່ອນ", {
               appearance: 'warning',
               autoDismiss: true,
            });
            return;
         }

         const isDuplicated = (liveStocks || []).some(
            (item) => item?.cfMessage?.toLowerCase() === selectedExistingStock?.cfMessage?.toLowerCase()
         );
         if (isDuplicated) {
            addToast("ສິນຄ້າລະຫັດ CF ນີ້ມີຢູ່ໃນໄລຟຢູ່ແລ້ວ", {
               appearance: 'error',
               autoDismiss: true,
            });
            return;
         }

         // const _create = await createLiveStock({
         const _create = await createLiveStock({
            variables: {
               data: {
                  amount,
                  amountAll: amount,
                  cfMessage: selectedExistingStock?.cfMessage,
                  cfCode: (selectedExistingStock?.cfMessage || '').toUpperCase(),
                  stock: selectedExistingStock?.id,
                  live: currentLiveId,
                  isDeleted: false,
                  shop: SHOP_ID,
               }
            }
         });

         const liveStockData = _create?.data?.createLiveStock || {};
         // if (_create?.data?.createLiveStock?.id) {
         if (liveStockData?.id) {
            const _newLiveStock = {
               id: liveStockData.id,
               amount,
               amountAll: amount,
               stock: {
                  id: selectedExistingStock?.id,
                  name: selectedExistingStock?.name,
                  amount: selectedExistingStock?.amount,
                  price: selectedExistingStock?.price,
                  originPrice: selectedExistingStock?.originPrice,
                  image: selectedExistingStock?.image,
                  isDeleted: false,
                  currency: selectedExistingStock?.currency,
               },
               isPublished: true,
               cfMessage: selectedExistingStock?.cfMessage,
            };

            setLiveStocks(prev => [_newLiveStock, ...prev]);
            seTotalLiveStock(prev => parseInt(prev || 0) + 1);

            addToast("ເພີ່ມສິນຄ້າສໍາເລັດ", {
               appearance: 'success',
               autoDismiss: true,
            });

            fetchLiveStocks();
            setShowAddStockModal(false);
            setExistingProductName("");
            setSelectedExistingStock(null);
            setExistingAmount("");
            setPrice("");
         }
      } catch (error) {
         console.error("Error in onAddExistingStock:", error);
         addToast("ເກີດຂໍ້ຜິດພາດໃນການເພີ່ມສິນຄ້າ", {
            appearance: 'error',
            autoDismiss: true,
         });
      }
   };


   return (
      <Modal 
      show={showAddStockModal} onHide={handleClose} centered size="lg">
         <Modal.Header>
            <Modal.Title>
               ເພີ່ມສິນຄ້າ
            </Modal.Title>
         </Modal.Header>
         <Modal.Body style={{ overflowY: "auto", maxHeight: "60vh",height:"55vh" }}>
            <Tabs id="add-stock-tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k || "new")}>
               <Tab eventKey="new" title="ສ້າງສິນຄ້າໃໝ່">
                  <div style={{ width: "100%", background: 'white', padding: 10 }}>
                     <div style={{ display: 'flex' }}>
                        <Form.Group>
                           <Form.Label>ລະຫັດ CF <span style={{ color: "red" }}>*</span></Form.Label>
                           <Form.Control
                              type="text"
                              name="cfMessage"
                              onChange={(e) => setCfMessage(e.target.value)}
                              value={cfMessage}
                              placeholder="ລະຫັດ CF..."
                           />
                        </Form.Group>
                        <div style={{ width: 10 }} />
                        <Form.Group>
                           <Form.Label>ຊື່ສິນຄ້າ <span style={{ color: "red" }}>*</span></Form.Label>
                           <Form.Control
                              type="text"
                              name="productTital"
                              onChange={(e) => setProductTital(e.target.value)}
                              value={productTital}
                              placeholder="ຊື່ສິນຄ້າ..."
                           />
                        </Form.Group>
                     </div>
                     <div style={{ display: 'flex', marginTop: 5 }}>
                        <Form.Group>
                           <Form.Label>ລາຄາຕົ້ນທືນ <span style={{ color: "red" }}>*</span></Form.Label>
                           <NumberFormat
                              name="stockOriginPriceLak"
                              onChange={(e) => setStockOriginPriceLak(e.target.value)}
                              value={stockOriginPriceLak}
                              className="form-control"
                              placeholder="0"
                              thousandSeparator={true}
                              prefix={''}
                           />
                        </Form.Group>
                        <div style={{ width: 5 }} />
                        <Form.Group>
                           <Form.Label>ລາຄາຂາຍ <span style={{ color: "red" }}>*</span></Form.Label>
                           <NumberFormat
                              name="stockPriceLak"
                              onChange={(e) => setStockPriceLak(e.target.value)}
                              value={stockPriceLak}
                              className="form-control"
                              placeholder="0"
                              thousandSeparator={true}
                              prefix={''}
                           />
                        </Form.Group>
                        <div style={{ width: 5 }} />
                        <Form.Group>
                           <Form.Label>ຈໍານວນ <span style={{ color: "red" }}>*</span></Form.Label>
                           <NumberFormat
                              name="stockAmount"
                              className="form-control"
                              onChange={(e) => setStockAmount(e.target.value)}
                              value={stockAmount}
                              placeholder="ຈໍານວນ"
                              thousandSeparator={true}
                              prefix={""}
                           />
                        </Form.Group>
                     </div>
                     <div className="col-12" style={{ display: 'flex', width: "100%" }}>
                        <div className="col-5" style={{ display: 'flex', padding: 0, margin: 0 }}>
                           <Form.Group controlId="exampleForm.ControlInput1">
                              <Form.Label>ສະກຸນເງິນ</Form.Label>
                              <div>
                                 <ButtonGroup aria-label="Currency selection">
                                    <Button
                                       variant="outline-secondary"
                                       style={{
                                          ...(currency === "ກີບ"
                                             ? { background: COLOR_APP, color: "#ffff", borderWidth: 0 }
                                             : {}),
                                          width: 60,
                                          borderRadius: 8
                                       }}
                                       onClick={() => setCurrency("ກີບ")}
                                    >
                                       ກີບ
                                    </Button>
                                    <Button
                                       variant="outline-secondary"
                                       style={{
                                          ...(currency === "ບາດ"
                                             ? { background: COLOR_APP, color: "#ffff", borderWidth: 0 }
                                             : {}),
                                          width: 60,
                                          marginLeft: 12,
                                          borderRadius: 8
                                       }}
                                       onClick={() => setCurrency("ບາດ")}
                                    >
                                       ບາດ
                                    </Button>
                                    <Button
                                       variant="outline-secondary"
                                       style={{
                                          ...(currency === "ໂດລາ"
                                             ? { background: COLOR_APP, color: "#ffff", borderWidth: 0 }
                                             : {}),
                                          width: 60,
                                          marginLeft: 12,
                                          borderRadius: 8
                                       }}
                                       onClick={() => setCurrency("ໂດລາ")}
                                    >
                                       ໂດລາ
                                    </Button>
                                 </ButtonGroup>
                              </div>
                           </Form.Group>
                        </div>
                     </div>
                     <div className="py-2">
                        <p>ການເລືອກ option ລະບົບຈະສ້າງສິນຄ້າຈຳນວນຫຼາຍຕາມທີ່ເລືອກໄດ້!</p>
                        {optionValueDatas?.optionValues?.total > 0 ? (
                           <div>
                              {Object.entries(_.groupBy(optionValueDatas?.optionValues?.data || [], 'name')).map(([groupName, items]) => (
                                 <div key={groupName} className="p-2" style={{ border: "1px solid #eee", background: "#fff", borderRadius: 5, marginBottom: 8 }}>
                                    <div style={{ fontWeight: 600, marginBottom: 6 }}>{groupName}</div>
                                    <div className="d-flex flex-wrap" style={{ gap: 5 }}>
                                       {items.map((option, index) => (
                                          <div key={option.id}  style={{ width:85,padding:"2px", border: "1px solid #e9ecef", borderRadius: 10}}>
                                             <Form.Check
                                                type="checkbox"
                                                style={{display:"flex", alignItems:"center", justifyContent:"center", gap:5}}
                                                id={`option-${option.id}`}
                                                checked={selectedOptions.includes(option.id)}
                                                onChange={() => handleOptionSelect(option)}
                                                label={<span style={{ fontSize: 12 }}>{option.value}</span>}
                                             />
                                          </div>
                                       ))}
                                    </div>
                                 </div>
                              ))}
                              <div style={{ color: "#6c757d", fontSize: 12, marginTop: 4 }}>
                                 ເລືອກ option ແລ້ວກົດ "ສ້າງລະຫັດ" ກ່ອນບັນທຶກ
                              </div>
                           </div>
                        ) : (
                           <div className="mt-2">
                              <p>ບໍ່ມີຂໍ້ມູນຕົວເລືອກ <a onClick={() => history.push("/settings-option-value")} style={{ color: "blue" }}><u>ເພີ່ມຕົວເລືອກ</u></a></p>
                           </div>
                        )}

                        <div className="mt-2">
                           <Button className="btn btn-app hoverme mr-2" variant="outline-info" onClick={onGenOption}>
                              ສ້າງລະຫັດ
                           </Button>
                        </div>

                        {selectedOptionRows.length > 0 && (
                           <div className="mt-3">
                              {Object.entries(_.groupBy(selectedOptionRows, (r) => `${r.primary?.name || ""} ${r.primary?.value || ""}`)).map(([key, rows]) => (
                                 <div key={key} className="p-2" style={{ border: "1px solid #eee", background: "#fff", borderRadius: 5, marginBottom: 8 }}>
                                    <h5>{rows[0]?.primary?.name || "-"} {rows[0]?.primary?.value || ""}</h5>
                                    {rows.map((row) => (
                                       <div key={`${row.primary?.id}-${row.secondary?.id}`} className="row" style={{ background: "white", marginBottom: 8 }}>
                                          <div className="col-2">
                                             <Form.Group>
                                                <Form.Label>ລະຫັດ CF</Form.Label>
                                                <Form.Control
                                                   type="text"
                                                   name="cfMessage"
                                                   value={row.cfMessage}
                                                   placeholder=""
                                                   disabled
                                                />
                                             </Form.Group>
                                          </div>
                                          <div className="col-3">
                                             <Form.Group>
                                                <Form.Label>{row.secondary?.name || row.secondary?.group || secondaryGroupName}</Form.Label>
                                                <Form.Control
                                                   type="text"
                                                   name="option"
                                                   value={row.secondary?.value}
                                                   placeholder="0"
                                                   disabled
                                                />
                                             </Form.Group>
                                          </div>
                                          <div className="col-2">
                                             <Form.Group>
                                                <Form.Label>ຈໍານວນ</Form.Label>
                                                <Form.Control
                                                   type="number"
                                                   name="amount"
                                                   min={0}
                                                   value={row.amount}
                                                   onChange={(e) => updateSelectedRow(row.primary?.id, row.secondary?.id, { amount: e.target.value })}
                                                   placeholder="0"
                                                   disabled
                                                />
                                             </Form.Group>
                                          </div>
                                          <div className="col-2">
                                             <Form.Group>
                                                <Form.Label>ລາຄາຕົ້ນທືນ ({currency})</Form.Label>
                                                <NumberFormat
                                                   name="originPrice"
                                                   className="form-control"
                                                   onChange={(e) => updateSelectedRow(row.primary?.id, row.secondary?.id, { originPrice: e.target.value })}
                                                   value={row.originPrice ?? ""}
                                                   placeholder="0"
                                                   thousandSeparator
                                                   prefix={""}
                                                />
                                             </Form.Group>
                                          </div>
                                          <div className="col-2">
                                             <Form.Group>
                                                <Form.Label>ລາຄາຂາຍ ({currency})</Form.Label>
                                                <NumberFormat
                                                   name="price"
                                                   className="form-control"
                                                   onChange={(e) => updateSelectedRow(row.primary?.id, row.secondary?.id, { price: e.target.value })}
                                                   value={row.price ?? ""}
                                                   placeholder="0"
                                                   thousandSeparator
                                                   prefix={""}
                                                />
                                             </Form.Group>
                                          </div>
                                          <div className="col-1">
                                             <Form.Group>
                                                <div>
                                                   <Form.Label style={{ color: "white" }}>Action</Form.Label>
                                                </div>
                                                <div>
                                                   <Form.Label>
                                                      <FontAwesomeIcon
                                                         icon={faTrashAlt}
                                                         style={{ color: "red", cursor: "pointer" }}
                                                         onClick={() => {
                                                            setSelectedOptionRows((prev) => prev.filter((r) => !(r.primary?.id === row.primary?.id && r.secondary?.id === row.secondary?.id)));
                                                         }}
                                                      />
                                                   </Form.Label>
                                                </div>
                                             </Form.Group>
                                          </div>
                                       </div>
                                    ))}
                                 </div>
                              ))}
                           </div>
                        )}
                     </div>
                  </div>
               </Tab>
               <Tab eventKey="existing" title="ສິນຄ້າທີ່ມີ">
                  <div style={{ width: "100%", background: 'white', padding: 10 }}>
                           <div className="row" style={{ marginBottom: width < 768 ? 12 : 16 }}>
                              <div className="col-md-12" style={{ marginBottom: width < 768 ? 8 : 16 }}>
                                 {/* input search */}
                                    <Form.Group>
                                    <Form.Label>ລະຫັດ CF</Form.Label>
                                    <div className="input-group" style={{fontSize: width < 768 ? 12 : 16}}>
                                       <Select
                                          options={selectOptions}
                                          isClearable
                                          isSearchable
                                          blurInputOnSelect={false}
                                          placeholder="ຄົ້ນຫາ & ເລືອກສິນຄ້າ"
                                          onChange={(option) => {
                                             onSelectExistingStockOption(option);
                                             setSearchInput("");
                                          }}
                                          onMenuScrollToBottom={loadMoreStocks}
                                          isLoading={fetchingMore || stocksLoading}
                                          loadingMessage={() => "ກຳລັງໂຫຼດ..."}
                                          inputValue={searchInput}
                                          noOptionsMessage={() => (fetchingMore || stocksLoading) ? "ກຳລັງໂຫຼດ..." : "ບໍ່ມີສິນຄ້າ"}
                                          onInputChange={(value, actionMeta) => {
                                             if (actionMeta?.action === "input-change") {
                                                setSearchInput(value || "");
                                                setPage((p) => ({ ...p, skip: 0 }));
                                             }
                                          }}
                                          value={
                                             selectedExistingStock
                                                 ? selectOptions.find((o) => o.value === (selectedExistingStock?.cfMessage || ""))
                                                 : null
                                          }
                                          styles={{
                                             container: (base) => ({ ...base, flex: 1 }),
                                          }}
                                          menuShouldScrollIntoView={false}
                                          components={{ MenuList }}
                                          filterOption={() => true}
                                       />
                                    </div>
                                 </Form.Group>
                              </div>
                           </div>
                           <div className="row" style={{ marginBottom: width < 768 ? 12 : 16 }}>
                              <div className="col-md-6">
                                 <Form.Group>
                                    <Form.Label>ຊື່ສິນຄ້າ</Form.Label>
                                    <Form.Control
                                       type="text"
                                       placeholder="ກະລຸນາປ້ອນຊື່ສິນຄ້າ"
                                       value={existingProductName}
                                       onChange={(e) => setExistingProductName(e.target.value)}
                                    />
                                 </Form.Group>
                              </div>
                              <div className="col-md-6" style={{ marginBottom: 12 }}>
                                 <Form.Group>
                                    <Form.Label>ຈໍານວນ</Form.Label>
                                    <NumberFormat
                                       name="existingAmount"
                                       className="form-control"
                                       onChange={(e) => setExistingAmount(e.target.value)}
                                       value={existingAmount}
                                       placeholder="ຈໍານວນ"
                                       thousandSeparator={true}
                                       prefix={""}
                                    />
                                 </Form.Group>
                              </div>
                              <div className="col-md-6" style={{ marginBottom: 12 }}>
                                 <Form.Group>
                                    <Form.Label>ລາຄາ</Form.Label>
                                    <NumberFormat
                                       name="price"
                                       className="form-control"
                                       // onChange={(e) => setPrice(e.target.value)}
                                       value={price}
                                       placeholder="ລາຄາ"
                                       thousandSeparator={true}
                                       prefix={""}
                                    />
                                 </Form.Group>
                              </div>
                           </div>
                        </div>
               </Tab>
            </Tabs>
         </Modal.Body>
         <Modal.Footer>
            <div className="col-12 mt-2" style={{ display: 'flex', flexDirection: 'row', justifyContent: "center", width: "100%", padding: 0, margin: 0 }}>
               <Button
                  onClick={handleClose}
                  style={{
                     margin: "2.5px 2.5px",
                     fontWeight: 'bold',
                     fontSize: 16,
                     background: "#fff",
                     alignItems: "center",
                     textAlign: "center",
                     border: "1px solid red",
                     color: "red",
                     width: 120,
                     height: 35,
                     borderRadius: 8
                  }}
                  disabled={createLoading}
               >
                  <FontAwesomeIcon icon={faTimes} />{` \t `}
                  ຍົກເລີກ
               </Button>
               <div style={{ width: 10 }} />
               <Button
                  onClick={activeTab === "new" ? onAddNewStock : onAddExistingStock}
                  style={{
                     margin: "2.5px 2.5px",
                     fontWeight: 'bold',
                     fontSize: 16,
                     background: COLOR_APP,
                     border: "none",
                     width: 120,
                     height: 35,
                     borderRadius: 8
                  }}
                  disabled={(activeTab === "new" ? createLoading : (createExistingLoading || !selectedExistingStock || parseNumber(existingAmount) <= 0))}
               >
                  {/* {(activeTab === "new" ? createLoading : createExistingLoading) */}
                  {(activeTab === "new" ? createLoading : createExistingLoading)
                     ? <Spinner size="sm" animation="border" />
                     : <FontAwesomeIcon icon={faSave} style={{ color: "#fff" }} />
                  }
                  {` \t `}
                  <span style={{ color: "#fff" }}>ບັນທຶກ</span>
               </Button>
            </div>
         </Modal.Footer>
      </Modal>
   );
}

export default AddStockModal;
